export default "__VITE_ASSET__BmGZUgBW__"